module.exports = __webpack_public_path__ + "static/media/wrapped_box.4936ed19.jpg";